import 'angular:locale/data:tr-TR';
import 'angular:locale/data:pt-PT';
import 'angular:locale/data:it-IT';
import 'angular:locale/data:fr-FR';
import 'angular:locale/data:es-ES';
import 'angular:locale/data:en-US';
import 'angular:locale/data:de-DE';
import 'angular:locale/data:fr-x-source';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
